import React from 'react';
import { PropTypes } from 'prop-types';
import GalleryTabs from './GalleryTabs';
import GallerySection from './GallerySection';

class Gallery extends React.Component {
    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }
    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }
    render() {
        let artworks = this.props.artworks;
        const sections = [
            {
                name: "Collages",
                id: "collage",
                artworks: artworks.filter((artwork) => {
                    return artwork.type === "collage";
                })
            },
            {
                name: "Watercolours",
                id: "watercolour",
                artworks: artworks.filter((artwork) => {
                    return artwork.type === "watercolour";
                })
            },
            {
                name: "Drawings",
                id: "drawing",
                artworks: artworks.filter((artwork) => {
                    return artwork.type === "drawing";
                })
            },
            {
                name: "Crafts",
                id: "craft",
                artworks: artworks.filter((artwork) => {
                    return artwork.type === "craft";
                })
            }
        ];

        return (
            <div className="gallery" >
                <GalleryTabs sections={sections} />
                <div className="gallery-sections">
                    {sections.map((section, i) => {
                        return (
                            section.artworks.length > 0 && <GallerySection key={i} name={section.name} id={section.id} artworks={section.artworks} body={section.body} />
                        );
                    })
                    }
                </div>
            </div>
        );
    }
}

Gallery.propTypes = {
    artworks: PropTypes.array.isRequired
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/gallery/Gallery.js